
export default {
  shapes: [
    {
      id: 'Round',
      label: 'Round',
      value: ['ROUND', 'ROUND-69', 'ROUND-HA', 'ROUND-ROSE', 'RO-BBS'],
      href: 'https://img.mobioffice.io/api/containers/37/download/be4c443a-3303-4792-b502-a86ea97a5217.jpg',
    },
    {
      id: 'Oval',
      label: 'Oval',
      value: [
        'FRENCH OVAL',
        'FRENCH-OVAL3',
        'French-Oval4',
        'MO1',
        'OVAL',
        'OVAL-GRD',
        'Oval K1',
        'OVAL-LEO',
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/6eed99db-1442-4803-a17f-e68c266f220d.jpg',
    },
    {
      id: 'Cushion',
      label: 'Cushion',
      value: [
        'CUSHION',
        'CUSHION-GRD',
        'Cushion-long',
        'CUS-AM',
        'CUS-GRD-LONG',
        'Shane-Cushion',
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/fdcbf9f0-5624-4bb2-992c-90909cc0341f.jpg',
    },
    {
      id: 'Cushion Brilliant',
      label: 'Cushion Brilliant',
      value: [
        'CLBR-2',
        'CLBR-4',
        'CLBR-5',
        'CLBR-SG',
        'CUSHION-NI',
        'CUSHION-BR',
        'CUSH-LONG-BRIL',
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/fdcbf9f0-5624-4bb2-992c-90909cc0341f.jpg',
    },
    {
      id: 'Pear',
      label: 'Pear',
      value: ['FRENCH PEAR', 'PEAR', 'PEAR-GRD', 'PEARS-JC'],
      href: 'https://img.mobioffice.io/api/containers/37/download/a0b59517-8072-459d-8aca-b1bd9a24deb5.jpg',
    },
    {
      id: 'Princess',
      label: 'Princess',
      value: ['PRINCESS', 'PRINCESS-LEO'],
      href: 'https://img.mobioffice.io/api/containers/37/download/bd7aca5e-34de-4d14-916d-6d2b9c231109.jpg',
    },
    {
      id: 'Emerald',
      label: 'Emerald',
      value: ['EMERALD', 'EMERALD-LEO', 'Emerald-ELT1', 'EM-H1'],
      href: 'https://img.mobioffice.io/api/containers/37/download/88995516-ccf5-4f76-9cf7-2ead92e24742.jpg',
    },
    {
      id: 'Radiant',
      label: 'Radiant',
      value: ['RADIANT', 'RADIANT-ACH', 'RADIANT-D1', 'RAD1-GRD', 'SQ-RAD'],
      href: 'https://img.mobioffice.io/api/containers/37/download/e6c3235c-847a-4066-ad4b-45295adf6cc6.jpg',
    },
    {
      id: 'Marquise',
      label: 'Marquise',
      value: ['FRENCH MARQUISE', 'MARQUISE', 'MQ-GRD'],
      href: 'https://img.mobioffice.io/api/containers/37/download/1a2729e3-06a1-4227-9d5f-4d5ef67069cf.jpg',
    },
    {
      id: 'Heart',
      label: 'Heart',
      value: ['HEART', 'HEART-WG', 'HR-HEART'],
      href: 'https://img.mobioffice.io/api/containers/37/download/a046fffe-431d-4fb6-af0d-b1f68feef12a.jpg',
    },
    {
      id: 'Asscher',
      label: 'Asscher',
      value: ['ASSCHER'],
      href: 'https://img.mobioffice.io/api/containers/37/download/a55b9aca-5da8-4551-9269-064c77480955.jpg',
    },
    {
      id: 'Old Euro',
      label: 'Old Euro',
      value: ['FL-OE', 'OLDEUROPEAN', 'OEC-VC'],
      href: 'https://img.mobioffice.io/api/containers/37/download/a55b9aca-5da8-4551-9269-064c77480955.jpg',
    },
    {
      id: 'Old Mine',
      label: 'Old Mine',
      value: ['OLD MINE', 'CUSH-OLD MINE1'],
      href: 'https://img.mobioffice.io/api/containers/37/download/a55b9aca-5da8-4551-9269-064c77480955.jpg',
    },
    {
      id: 'Sq Emerald',
      label: 'Sq Emerald',
      value: ['SQ EMERALD'],
      href: 'https://img.mobioffice.io/api/containers/37/download/a55b9aca-5da8-4551-9269-064c77480955.jpg',
    },
  ],
  advancedShapes: [
    {
      id: 'Round H&A',
      label: 'Round H&A',
      value: ['ROUND-HA'],
      href: 'https://img.mobioffice.io/api/containers/37/download/be4c443a-3303-4792-b502-a86ea97a5217.jpg',
    },
    {
      id: 'French Oval',
      label: 'French Oval',
      value: [
        'FRENCH OVAL',
        'MO1',
        'OVAL-GRD',
        'FRENCH-OVAL3',
        'Oval K1',
        'French-Oval4',
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/6eed99db-1442-4803-a17f-e68c266f220d.jpg',
    },
    {
      id: 'Hybrid Cushion',
      label: 'Hybrid Cushion',
      value: ['CUSHION-GRD', 'CUS-GRD-LONG'],
      href: 'https://img.mobioffice.io/api/containers/37/download/fdcbf9f0-5624-4bb2-992c-90909cc0341f.jpg',
    },
    {
      id: 'Cushion Brilliant',
      label: 'Cushion Brilliant',
      value: ['CUSHION-NI', 'CUSH-LONG-BRIL', 'CLBR-2', 'CUSHION-BR'],
      href: 'https://img.mobioffice.io/api/containers/37/download/fdcbf9f0-5624-4bb2-992c-90909cc0341f.jpg',
    },
    {
      id: 'French Pear',
      label: 'French Pear',
      value: ['PEAR-GRD', 'FRENCH PEAR'],
      href: 'https://img.mobioffice.io/api/containers/37/download/a0b59517-8072-459d-8aca-b1bd9a24deb5.jpg',
    },
    {
      id: 'Hybrid Radiant',
      label: 'Hybrid Radiant',
      value: ['RAD1-GRD'],
      href: 'https://img.mobioffice.io/api/containers/37/download/e6c3235c-847a-4066-ad4b-45295adf6cc6.jpg',
    },
    {
      id: 'French Marquise',
      label: 'French Marquise',
      value: ['MQ-GRD', 'FRENCH MARQUISE'],
      href: 'https://img.mobioffice.io/api/containers/37/download/1a2729e3-06a1-4227-9d5f-4d5ef67069cf.jpg',
    },
    {
      id: 'Elite Emerald',
      label: 'Elite Emerald',
      value: ['Emerald-ELT1', 'Emerald-ELT2'],
      href: 'https://img.mobioffice.io/api/containers/37/download/1a2729e3-06a1-4227-9d5f-4d5ef67069cf.jpg',
    },
  ],
  colors: [
    {
      id: 'D',
      label: 'D',
      value: 'D',
      href: 'https://img.mobioffice.io/api/containers/37/download/490b1d2c-5e15-4c61-a4f5-be591d99e26e.jpg',
    },
    {
      id: 'E',
      label: 'E',
      value: 'E',
      href: 'https://img.mobioffice.io/api/containers/37/download/159152f4-fd93-477e-818a-505e44797772.jpg',
    },
    {
      id: 'F',
      label: 'F',
      value: 'F',
      href: 'https://img.mobioffice.io/api/containers/37/download/b1c37077-c69f-4dcf-9b03-15313a035aec.jpg',
    },
    {
      id: 'G',
      label: 'G',
      value: 'G',
      href: 'https://img.mobioffice.io/api/containers/37/download/771f8b03-c82c-44dd-8a37-63d71a358648.jpg',
    },
    {
      id: 'H',
      label: 'H',
      value: 'H',
      href: 'https://img.mobioffice.io/api/containers/37/download/564580b5-3a43-4ad8-9b97-248b1db0dd14.jpg',
    },
    {
      id: 'I',
      label: 'I',
      value: 'I',
      href: 'https://img.mobioffice.io/api/containers/37/download/a1ebd80c-8630-4e80-a9d2-b99e9dad5b5d.jpg',
    },
    {
      id: 'J',
      label: 'J',
      value: 'J',
      href: 'https://img.mobioffice.io/api/containers/37/download/cfe371f6-62d3-4213-afef-5342ef66c8aa.jpg',
    },
    {
      id: 'K',
      label: 'K',
      value: 'K',
      href: 'https://img.mobioffice.io/api/containers/37/download/c4a96dab-13f4-4617-9623-520f927cc941.jpg',
    },
    {
      id: 'L',
      label: 'L',
      value: 'L',
      href: 'https://img.mobioffice.io/api/containers/37/download/955da583-b52f-4ded-b271-c5203ffa5ce8.jpg',
    },
    {
      id: 'M',
      label: 'M',
      value: 'M',
      href: 'https://img.mobioffice.io/api/containers/37/download/9aa7ce62-67f7-45bf-93af-0e8825aec695.jpg',
    },
    {
      id: 'N',
      label: 'N',
      value: 'N',
      href: 'https://img.mobioffice.io/api/containers/37/download/cad6c9ba-13d1-4f4b-ad04-09181405dc31.jpg',
    },
    {
      id: 'N-Z',
      label: 'N-Z',
      value: [
        'O',
        'P',
        'N-O',
        'O-P',
        'P-R',
        'Q-R',
        'S-T',
        'U-V',
        'W-X',
        'Y-Z',
        'S-Z',
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/577639fd-7b1b-4694-9d4e-be0b12584dbd.jpg',
    },
  ],
  clarities: [
    {
      id: 'FL',
      label: 'FL',
      value: { FL: 'FL' },
      href: 'https://img.mobioffice.io/api/containers/37/download/f0ad9ee3-0c1c-4ce7-894c-e05bf7daf9e9.jpg',
    },
    {
      id: 'IF',
      label: 'IF',
      value: { IF: 'IF' },
      href: 'https://img.mobioffice.io/api/containers/37/download/f0ad9ee3-0c1c-4ce7-894c-e05bf7daf9e9.jpg',
    },
    {
      id: 'VVS1',
      label: 'VVS1',
      value: { VVS1: 'VVS1' },
      href: 'https://img.mobioffice.io/api/containers/37/download/c717a45d-bb42-496c-b546-b326bd435ba8.jpg',
    },
    {
      id: 'VVS2',
      label: 'VVS2',
      value: { VVS2: 'VVS2' },
      href: 'https://img.mobioffice.io/api/containers/37/download/c717a45d-bb42-496c-b546-b326bd435ba8.jpg',
    },
    {
      id: 'VS1',
      label: 'VS1',
      value: { VS1: 'VS1' },
      href: 'https://img.mobioffice.io/api/containers/37/download/38a433ea-38c9-484a-9239-b2fd85c4d194.jpg',
    },
    {
      id: 'VS2',
      label: 'VS2',
      value: { VS2: 'VS2' },
      href: 'https://img.mobioffice.io/api/containers/37/download/38a433ea-38c9-484a-9239-b2fd85c4d194.jpg',
    },
    {
      id: 'SI1',
      label: 'SI1',
      value: { SI1: 'SI1' },
      href: 'https://img.mobioffice.io/api/containers/37/download/2fccaaeb-6e82-4867-8d9d-03bbd30e23ee.jpg',
    },
    {
      id: 'SI2',
      label: 'SI2',
      value: { SI2: 'SI2' },
      href: 'https://img.mobioffice.io/api/containers/37/download/2fccaaeb-6e82-4867-8d9d-03bbd30e23ee.jpg',
    },
    {
      id: 'SI3',
      label: 'SI3',
      value: { SI3: ['SI3', 'SI3-', 'SI3+'] },
      href: 'https://img.mobioffice.io/api/containers/37/download/2fccaaeb-6e82-4867-8d9d-03bbd30e23ee.jpg',
    },
    {
      id: 'I1',
      label: 'I1',
      value: { I1: ['I1', 'I1-', 'I1+', 'I1++'] },

      href: 'https://img.mobioffice.io/api/containers/37/download/e5fb89fb-624a-4365-9f69-be0666dac508.jpg',
    },
    {
      id: 'I2',
      label: 'I2',
      value: { I2: ['I2', 'I2-', 'I2+', 'I2++'] },
      href: 'https://img.mobioffice.io/api/containers/37/download/834b25e1-5766-4161-82c9-5d561a269bf7.jpg',
    },
    {
      id: 'I3',
      label: 'I3',
      value: { I3: ['I3', 'I3-', 'I3+', 'I3++'] },
      href: 'https://img.mobioffice.io/api/containers/37/download/9674ca31-9172-48b9-a187-ec28cc485ddd.jpg',
    },
  ],
  advancedClarities: [
    {
      id: 'SI3+',
      label: 'SI3+',
      value: 'SI3+',
    },
    {
      id: 'SI3',
      label: 'SI3',
      value: 'SI3',
    },
    {
      id: 'SI3-',
      label: 'SI3-',
      value: 'SI3-',
    },
    {
      id: 'I1+',
      label: 'I1+',
      value: 'I1+',
    },
    {
      id: 'I1',
      label: 'I1',
      value: 'I1',
    },
    {
      id: 'I1-',
      label: 'I1-',
      value: 'I1-',
    },
    {
      id: 'I2+',
      label: 'I2+',
      value: 'I2+',
    },
    {
      id: 'I2',
      label: 'I2',
      value: 'I2',
    },
    {
      id: 'I2-',
      label: 'I2-',
      value: 'I2-',
    },
    {
      id: 'I3+',
      label: 'I3+',
      value: 'I3+',
    },
    {
      id: 'I3',
      label: 'I3',
      value: 'I3',
    },
    {
      id: 'I3-',
      label: 'I3-',
      value: 'I3-',
    },
  ],
  descriptions: [
    {
      label: 'No BGM',
      value: 'No BGM',
      href: 'https://img.mobioffice.io/api/containers/37/download/7961bdf9-78b4-4379-aa90-ee6835199e1b.jpg',
      para: [
        {
          label: 'ShadesCode',
          value: 'NONE',
        },
        {
          label: 'LusterCode',
          value: 'VG',
        },
        {
          label: 'LusterCode',
          value: 'GD',
        },
        {
          label: 'LusterCode',
          value: 'EX',
        },
        {
          label: 'LusterCode',
          value: 'FR',
        },
      ],
    },
    {
      label: '100% Eye Clean',
      value: 'EYE Clean',
      secondaryText: '100%',
      para: [
        {
          label: 'EyeCleanCode',
          value: 'Yes',
        },
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/93d69f35-dd18-4e35-9f23-b8a3b89187db.jpg',
    },
    {
      label: '80% Eye Clean',
      value: 'Eye Clean',
      secondaryText: '80',
      para: [
        {
          label: 'EyeCleanCode',
          value: '80%',
        },
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/10a98213-9896-432a-9940-02a9e35fc88f.jpg',
    },
    {
      label: 'Heart And Arrow',
      value: 'HeartandArrowCode',
      secondaryText: '',
      para: [
        {
          label: 'HeartandArrowCode',
          value: 'Y',
        },
      ],
      href: 'https://img.mobioffice.io/api/containers/37/download/93d69f35-dd18-4e35-9f23-b8a3b89187db.jpg',
    },
  ],
  diamondType: [
    {
      id: 'IIA',
      label: 'IIA',
      value: 'Type IIa',
      query: [
        {
          match: {
            DiamondType: 'Type IIa',
          },
        },
      ],
    },
  ],
  eligibility: [
    {
      id: 'DORRoughNo',
      label: 'DOR',
      value: 'DOR',
      query: [
        {
          exists: {
            field: 'DORRoughNo',
          },
        },
      ],
    },
    {
      id: 'Tracr',
      label: 'Tracr',
      value: 'Tracr',
       query: [
        {
          match: {
            tracerEligible: 'Y',
          },
        },
      ],
    },
  ],
  cuts: [
    {
      id: 'EX',
      label: 'EX',
      value: 'EXCL',
    },
    {
      id: 'VG',
      label: 'VG',
      value: 'VGOOD',
    },
    {
      id: 'GD',
      label: 'GD',
      value: 'GOOD',
    },
    {
      id: 'FR',
      label: 'FR',
      value: 'FAIR',
    },
  ],
  polishes: [
    {
      id: 'EX',
      label: 'EX',
      value: 'EXCL',
    },
    {
      id: 'VG',
      label: 'VG',
      value: 'VGOOD',
    },
    {
      id: 'GD',
      label: 'GD',
      value: 'GOOD',
    },
    {
      id: 'FR',
      label: 'FR',
      value: 'FAIR',
    },
  ],
  symmetries: [
    {
      id: 'EX',
      label: 'EX',
      value: 'EXCL',
    },
    {
      id: 'VG',
      label: 'VG',
      value: 'VGOOD',
    },
    {
      id: 'GD',
      label: 'GD',
      value: 'GOOD',
    },
    {
      id: 'FR',
      label: 'FR',
      value: 'FAIR',
    },
  ],
  finishings: [
    {
      label: '3EX',
      value: '3EX',
    },
    {
      label: 'EX-',
      value: 'EX-',
    },
    {
      label: 'VG+',
      value: 'VG+',
    },
    {
      label: 'VG-',
      value: 'VG-',
    },
    {
      label: 'GD+',
      value: 'GD+',
    },
  ],
  fluorescences: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Faint',
      value: ['VERY SLIGHT', 'SLIGHT', 'FAINT'],
    },
    {
      label: 'Medium',
      value: 'MEDIUM',
    },
    {
      label: 'Strong',
      value: 'STRONG',
    },
    {
      label: 'Very Strong',
      value: 'VSTRONG',
    },
  ],
  // labs: [
  //   // {
  //   //   label: 'GIA',
  //   //   value: 'GIA',
  //   // },
  //   // {
  //   //   label: 'HRD',
  //   //   value: 'HRD',
  //   // },
  //   // {
  //   //   label: 'FM',
  //   //   value: ['FM01', 'FM02', 'BLFM'],
  //   // },
  //   // {
  //   //   label: 'IGI',
  //   //   value: 'IGI',
  //   // },
  //   // {
  //   //   label: 'GSI',
  //   //   value: 'GSI',
  //   // },
  //   // {
  //   //   label: 'KG LAB',
  //   //   value: ['KGLAB', 'KGSU'],
  //   // },
  //   // {
  //   //   label: 'NGTC',
  //   //   value: 'NGTC',
  //   // },
  //   // {
  //   //   label: 'DBO',
  //   //   value: 'DBO',
  //   // },
  //   // {
  //   //   label: 'NON CERT',
  //   //   value: 'NONE CERT',
  //   //   hideCount: true,
  //   // },
  // ],
  // origin: [
  //   {
  //     label: 'BOTSWANA',
  //     value: 'BOTSWANA',
  //   },
  //   // {
  //   //   label: 'RUSSIA',
  //   //   value: 'RUSSIA',
  //   // },
  //   {
  //     label: 'CANADA',
  //     value: 'CANADA',
  //   },
  //   {
  //     label: 'SOUTH AFRICA',
  //     value: 'SOUTH AFRICA',
  //   },
  //   // {
  //   //   label: 'MIXED',
  //   //   value: 'MIXED',
  //   // },
  //   {
  //     label: 'ANGOLA',
  //     value: 'ANGOLA',
  //   },
  //   {
  //     label: 'TANZANIA',
  //     value: 'TANZANIA',
  //   },
  //   {
  //     label: 'NAMIBIA',
  //     value: 'NAMIBIA',
  //   },
  //   {
  //     label: 'BOTS-NAMI-SA-CAN',
  //     value: 'BOTS-NAMI-SA-CAN',
  //   },
  //   {
  //     label: 'SIERRA LEONE',
  //     value: 'SIERRA LEONE',
  //   },
  //   {
  //     label: 'LESOTHO',
  //     value: 'LESOTHO',
  //   },
  //   {
  //     label: 'AFRICA',
  //     value: 'AFRICA',
  //   },
  // ],

  traceabilityProtocol: [
    {
      id: 'Tracr',
      label: 'Tracr',
      value: 'Tracrid',
      query: [
        {
          exists: {
            field: 'tracrId',
          },
        },
      ],
    },
    {
      id: 'Diamond Origin Report (GIA)',
      label: 'Diamond Origin Report (GIA)',
      value: 'DOR',
      query: [
        {
          match: {
            ReportType: 'DOR',
          },
        },
      ],
    },
    // {
    //   id: 'Canadamark',
    //   label: 'Canadamark',
    //   value: 'Canadamark',
    // },
    {
      id: 'Source Verification Service (GIA)',
      label: 'Source Verification Service (GIA)',
      value: 'Source Verification Service (GIA)',
      query: [
        {
          exists: {
            field: 'DisclosedSource',
          },
        },
        // {
        //   bool: {
        //     should: {
        //       exists: {
        //         field: 'DisclosedSource',
        //       },
        //     },
        //   },
        // },
      ],
    },
  ],
  externalStatus: [
    {
      label: 'Available',
      value: 'Available',
    },
    // {
    //     "label": "On Memo",
    //     "value": "On Memo"
    // },
  ],
  fancyColorIntensities: [
    // {
    //   id: 'ALL',
    //   label: 'ALL',
    //   value: 'ALL',
    // },
    {
      id: 'FAINT',
      label: 'FAINT',
      value: 'FAINT',
    },
    {
      id: 'VERY LIGHT',
      label: 'VERY LIGHT',
      value: 'VERY LIGHT',
    },
    {
      id: 'LIGHT',
      label: 'LIGHT',
      value: 'LIGHT',
    },
    {
      id: 'FANCY LIGHT',
      label: 'FANCY LIGHT',
      value: 'FANCY LIGHT',
    },
    {
      id: 'FANCY',
      label: 'FANCY',
      value: 'FANCY',
    },
    {
      id: 'FANCY DARK',
      label: 'FANCY DARK',
      value: 'FANCY DARK',
    },
    {
      id: 'FANCY INTENSE',
      label: 'FANCY INTENSE',
      value: 'FANCY INTENSE',
    },
    {
      id: 'FANCY VIVID',
      label: 'FANCY VIVID',
      value: 'FANCY VIVID',
    },
    {
      id: 'FANCY DEEP',
      label: 'FANCY DEEP',
      value: 'FANCY DEEP',
    },
  ],
  selectedFancyColorIntensity: [],
  fancyColorOvertones: [
    // {
    //   id: 'ALL',
    //   label: 'ALL',
    //   value: 'ALL',
    // },
    // {
    //   id: 'NONE',
    //   label: 'NONE',
    //   value: 'NONE',
    // },
    {
      id: 'YELLOWISH',
      label: 'YELLOWISH',
      value: 'YELLOWISH',
    },
    {
      id: 'PINKISH',
      label: 'PINKISH',
      value: 'PINKISH',
    },
    {
      id: 'BLUISH',
      label: 'BLUISH',
      value: 'BLUISH',
    },
    {
      id: 'GREENISH',
      label: 'GREENISH',
      value: 'GREENISH',
    },
    {
      id: 'PURPLISH',
      label: 'PURPLISH',
      value: 'PURPLISH',
    },
    {
      id: 'ORANGY',
      label: 'ORANGY',
      value: 'ORANGY',
    },
    {
      id: 'GRAYISH',
      label: 'GRAYISH',
      value: 'GRAYISH',
    },
    {
      id: 'BROWNISH',
      label: 'BROWNISH',
      value: 'BROWNISH',
    },
    {
      id: 'BROWNISH GREENISH',
      label: 'BROWNISH GREENISH',
      value: 'BROWNISH GREENISH',
    },
    {
      id: 'BROWNISH YELLOWISH',
      label: 'BROWNISH YELLOWISH',
      value: 'BROWNISH YELLOWISH',
    },
    {
      id: 'GRAYISH GREENISH',
      label: 'GRAYISH GREENISH',
      value: 'GRAYISH GREENISH',
    },
    {
      id: 'GRAYISH YELLOWISH',
      label: 'GRAYISH YELLOWISH',
      value: 'GRAYISH YELLOWISH',
    },
    {
      id: 'BROWN-GREENISH',
      label: 'BROWN-GREENISH',
      value: 'BROWN-GREENISH',
    },
    {
      id: 'BROWNISH ORANGY',
      label: 'BROWNISH ORANGY',
      value: 'BROWNISH ORANGY',
    },
    {
      id: 'GRAY-GREENISH',
      label: 'GRAY-GREENISH',
      value: 'GRAY-GREENISH',
    },
    {
      id: 'GRAY-YELLOWISH',
      label: 'GRAY-YELLOWISH',
      value: 'GRAY-YELLOWISH',
    },
  ],
  selectedFancyColorOvertone: [],
  fancyColors: [
    {
      id: 'YELLOW',
      label: 'YELLOW',
      value: 'YELLOW',
    },
    {
      id: 'PINK',
      label: 'PINK',
      value: 'PINK',
    },
    {
      id: 'BLUE',
      label: 'BLUE',
      value: 'BLUE',
    },
    {
      id: 'GREEN',
      label: 'GREEN',
      value: 'GREEN',
    },
    {
      id: 'PURPLE',
      label: 'PURPLE',
      value: 'PURPLE',
    },
    {
      id: 'ORANGE',
      label: 'ORANGE',
      value: 'ORANGE',
    },
    {
      id: 'GRAY',
      label: 'GRAY',
      value: 'GRAY',
    },
    {
      id: 'BROWN',
      label: 'BROWN',
      value: 'BROWN',
    },
    {
      id: 'BROWN-ORANGE',
      label: 'BROWN-ORANGE',
      value: 'BROWN-ORANGE',
    },
    {
      id: 'BROWN-PINK',
      label: 'BROWN-PINK',
      value: 'BROWN-PINK',
    },
    {
      id: 'GREEN-YELLOW',
      label: 'GREEN-YELLOW',
      value: 'GREEN-YELLOW',
    },
    {
      id: 'ORANGE-YELLOW',
      label: 'ORANGE-YELLOW',
      value: 'ORANGE-YELLOW',
    },
    {
      id: 'PINK-PURPLE',
      label: 'PINK-PURPLE',
      value: 'PINK-PURPLE',
    },
    {
      id: 'PURPLE-PINK',
      label: 'PURPLE-PINK',
      value: 'PURPLE-PINK',
    },
    {
      id: 'YELLOW-GREEN',
      label: 'YELLOW-GREEN',
      value: 'YELLOW-GREEN',
    },
    {
      id: 'YELLOW-ORANGE',
      label: 'YELLOW-ORANGE',
      value: 'YELLOW-ORANGE',
    },
    {
      id: 'BROWN-YELLOW',
      label: 'BROWN-YELLOW',
      value: 'BROWN-YELLOW',
    },
    {
      id: 'YELLOW-GRAY',
      label: 'YELLOW-GRAY',
      value: 'YELLOW-GRAY',
    },
    {
      id: 'BLUE-GREEN',
      label: 'BLUE-GREEN',
      value: 'BLUE-GREEN',
    },
    {
      id: 'GREEN-BLUE',
      label: 'GREEN-BLUE',
      value: 'GREEN-BLUE',
    },
    {
      id: 'GRAY-BLUE',
      label: 'GRAY-BLUE',
      value: 'GRAY-BLUE',
    },
    {
      id: 'PINK-BROWN',
      label: 'PINK-BROWN',
      value: 'PINK-BROWN',
    },
    {
      id: 'YELLOW-BROWN',
      label: 'YELLOW-BROWN',
      value: 'YELLOW-BROWN',
    },
    {
      id: 'ORANGE-BROWN',
      label: 'ORANGE-BROWN',
      value: 'ORANGE-BROWN',
    },
  ],
  selectedFancyColor: [],
  sizeGroups: [
    {
      id: '0.30 - 0.39',
      label: '0.30 - 0.39',
      from: '0.30',
      to: '0.39',
      value: '0.30-0.39',
    },
    {
      id: '0.40 - 0.49',
      label: '0.40 - 0.49',
      from: '0.40',
      to: '0.49',
      value: '0.40-0.49',
    },
    {
      id: '0.50 - 0.69',
      label: '0.50 - 0.69',
      from: '0.50',
      to: '0.69',
      value: '0.50-0.69',
    },
    {
      id: '0.70 - 0.89',
      label: '0.70 - 0.89',
      from: '0.70',
      to: '0.89',
      value: '0.70-0.89',
    },
    {
      id: '0.90 - 0.99',
      label: '0.90 - 0.99',
      from: '0.90',
      to: '0.99',
      value: '0.90-0.99',
    },
    {
      id: '1.00 - 1.49',
      label: '1.00 - 1.49',
      from: '1.00',
      to: '1.49',
      value: '1.00-1.49',
    },
    {
      id: '1.50 - 1.99',
      label: '1.50 - 1.99',
      from: '1.50',
      to: '1.99',
      value: '1.50-1.99',
    },
    {
      id: '2.00 - 2.99',
      label: '2.00 - 2.99',
      from: '2.00',
      to: '2.99',
      value: '2.00-2.99',
    },
    {
      id: '3.00 - 4.99',
      label: '3.00 - 4.99',
      from: '3.00',
      to: '4.99',
      value: '3.00-4.99',
    },
    {
      id: '5.00+',
      label: '5.00+',
      from: '5.00',
      value: '5.00+',
    },
  ],
  selectedSizeGroup: '',
  saveSearchName: '',
  fromCarat: '',
  toCarat: '',
  specificCaratGroup: [],
  stoneId: '',
  certNo: '',
  stoneIdORCertSelected: 'stoneId',
  colorType: 'white',
  caratType: 'specific',
  clarityType: 'basic',
  finishingType: 'general',
  shapeType: 'generic',
  advancedColorType: 'Intensity',
  specificFinishingType: 'Cut',
  keyToSymbolType: 'contains',
  tablePerFrom: '',
  tablePerTo: '',
  depthPerFrom: '',
  depthPerTo: '',
  lengthFrom: '',
  lengthTo: '',
  widthFrom: '',
  widthTo: '',
  heightFrom: '',
  heightto: '',
  depthFrom: '',
  depthTo: '',
  ratioFrom: '',
  ratioTo: '',
  crownAngleFrom: '',
  crownAngleTo: '',
  pavilionAngleFrom: '',
  pavilionAngleTo: '',
  crownHeightFrom: '',
  crownHeightTo: '',
  discountPerFrom: '',
  discountPerTo: '',
  pricePerFrom: '',
  pricePerTo: '',
  amtPerFrom: '',
  amtPerTo: '',
  girdles: [
    {
      label: 'ETN',
      value: 'ETN',
    },
    {
      label: 'ETN TO VTN',
      value: 'ETN TO VTN',
    },
    {
      label: 'ETN TO THN',
      value: 'ETN TO THN',
    },
    {
      label: 'ETN TO STN',
      value: 'ETN TO STN',
    },
    {
      label: 'ETN TO MED',
      value: 'ETN TO MED',
    },
    {
      label: 'ETN TO STK',
      value: 'ETN TO STK',
    },
    {
      label: 'ETN TO THK',
      value: 'ETN TO THK',
    },
    {
      label: 'ETN TO VTK',
      value: 'ETN TO VTK',
    },
    {
      label: 'ETN TO ETK',
      value: 'ETN TO ETK',
    },
    {
      label: 'VTN',
      value: 'VTN',
    },
    {
      label: 'VTN TO THN',
      value: 'VTN TO THN',
    },
    {
      label: 'VTN TO STN',
      value: 'VTN TO STN',
    },
    {
      label: 'VTN TO MED',
      value: 'VTN TO MED',
    },
    {
      label: 'VTN TO STK',
      value: 'VTN TO STK',
    },
    {
      label: 'VTN TO THK',
      value: 'VTN TO THK',
    },
    {
      label: 'VTN TO VTK',
      value: 'VTN TO VTK',
    },
    {
      label: 'VTN TO ETK',
      value: 'VTN TO ETK',
    },
    {
      label: 'THN',
      value: 'THN',
    },
    {
      label: 'THN TO STN',
      value: 'THN TO STN',
    },
    {
      label: 'THN TO MED',
      value: 'THN TO MED',
    },
    {
      label: 'THN TO STK',
      value: 'THN TO STK',
    },
    {
      label: 'THN TO THK',
      value: 'THN TO THK',
    },
    {
      label: 'THN TO VTK',
      value: 'THN TO VTK',
    },
    {
      label: 'THN TO ETK',
      value: 'THN TO ETK',
    },
    {
      label: 'STN',
      value: 'STN',
    },
    {
      label: 'STN TO MED',
      value: 'STN TO MED',
    },
    {
      label: 'STN TO STK',
      value: 'STN TO STK',
    },
    {
      label: 'STN TO THK',
      value: 'STN TO THK',
    },
    {
      label: 'STN TO VTK',
      value: 'STN TO VTK',
    },
    {
      label: 'STN TO ETK',
      value: 'STN TO ETK',
    },
    {
      label: 'MED',
      value: 'MED',
    },
    {
      label: 'MED TO STK',
      value: 'MED TO STK',
    },
    {
      label: 'MED TO THK',
      value: 'MED TO THK',
    },
    {
      label: 'MED TO VTK',
      value: 'MED TO VTK',
    },
    {
      label: 'MED TO ETK',
      value: 'MED TO ETK',
    },
    {
      label: 'STK',
      value: 'STK',
    },
    {
      label: 'STK TO THK',
      value: 'STK TO THK',
    },
    {
      label: 'STK TO VTK',
      value: 'STK TO VTK',
    },
    {
      label: 'STK TO ETK',
      value: 'STK TO ETK',
    },
    {
      label: 'THK',
      value: 'THK',
    },
    {
      label: 'THK TO VTK',
      value: 'THK TO VTK',
    },
    {
      label: 'THK TO ETK',
      value: 'THK TO ETK',
    },
    {
      label: 'VTK',
      value: 'VTK',
    },
    {
      label: 'VTK TO ETK',
      value: 'VTK TO ETK',
    },
    {
      label: 'ETK',
      value: 'ETK',
    },
  ],
  girdleOptions: [
    {
      label: 'Extra Thin',
      value: 'ETN',
    },
    {
      label: 'Very Thin',
      value: 'VTN',
    },
    {
      label: 'Thin',
      value: 'THN',
    },
    {
      label: 'Slightly Thin',
      value: 'STN',
    },
    {
      label: 'Medium',
      value: 'MED',
    },
    {
      label: 'Slightly thick',
      value: 'STK',
    },
    {
      label: 'Thick',
      value: 'THK',
    },
    {
      label: 'Very Thick',
      value: 'VTK',
    },
    {
      label: 'Extra Thick',
      value: 'ETK',
    },
  ],
  selectedGirdle: '',
  selectedGirdleFrom: '',
  selectedGirdleTo: '',
  pavilionHeightFrom: '',
  pavilionHeightTo: '',
  pavilionDepthFrom: '',
  pavilionDepthTo: '',
  fm: [
    {
      label: 'FM Eligible',
      value: 'FM Eligible',
      query: [
        {
          bool: {
            must: {
              exists: {
                field: 'FmStr',
              },
            },
          },
        },
      ],
      hideCount: true,
    },
    {
      label: 'FM Inscription',
      value: 'FM INSCRIPTION',
      query: [
        {
          bool: {
            must: {
              exists: {
                field: 'FMInscription',
              },
            },
          },
        },
      ],
      hideCount: true,
    },
    {
      label: 'No FM Inscription',
      value: 'NO FM INSCRIPTION',
      query: [
        {
          bool: {
            must_not: {
              exists: {
                field: 'FMInscription',
              },
            },
          },
        },
      ],
      hideCount: true,
    },
  ],
  location: [
    {
      id: 'mumbai',
      label: 'Mumbai',
      value: 'mumbai',
    },
    {
      id: 'ny',
      label: 'New York',
      value: 'ny,aspecony',
    },
    {
      id: 'hk',
      label: 'Hong Kong',
      value: 'hk',
    },
    {
      id: 'aspeconv',
      label: 'Antwerp',
      value: 'aspeconv',
    },
    {
      id: 'dmcc',
      label: 'Dubai',
      value: 'dmcc',
    },
    {
      id: 'shanghai',
      label: 'Shanghai',
      value: 'shanghai',
    },
    {
      id: 'london',
      label: 'London',
      value: 'london',
    },
  ],
  keyToSymbol: [
    {
      id: 'Minor Details of Polish',
      label: 'Minor Details of Polish',
      value: 'Minor Details of Polish',
    },
    {
      id: 'Natural',
      label: 'Natural',
      value: 'Natural',
    },
    {
      id: 'Surface Graining',
      label: 'Surface Graining',
      value: 'Surface Graining',
    },
    {
      id: 'Pinpoint',
      label: 'Pinpoint',
      value: 'Pinpoint',
    },
    {
      id: 'Chip',
      label: 'Chip',
      value: 'Chip',
    },
    {
      id: 'Feather',
      label: 'Feather',
      value: 'Feather',
    },
    {
      id: 'Internal Graining',
      label: 'Internal Graining',
      value: 'Internal Graining',
    },
    {
      id: 'Indented Natural',
      label: 'Indented Natural',
      value: 'Indented Natural',
    },
    {
      id: 'Etch Channel',
      label: 'Etch Channel',
      value: 'Etch Channel',
    },
    {
      id: 'Cloud',
      label: 'Cloud',
      value: 'Cloud',
    },
    {
      id: 'Cavity',
      label: 'Cavity',
      value: 'Cavity',
    },
    {
      id: 'Manufacturing Remnant',
      label: 'Manufacturing Remnant',
      value: 'Manufacturing Remnant',
    },
    {
      id: 'Extra Facet',
      label: 'Extra Facet',
      value: 'Extra Facet',
    },
    {
      id: 'Needle',
      label: 'Needle',
      value: 'Needle',
    },
    {
      id: 'Crystal',
      label: 'Crystal',
      value: 'Crystal',
    },
    {
      id: 'Knot',
      label: 'Knot',
      value: 'Knot',
    },
    {
      id: 'Twinning Wisp',
      label: 'Twinning Wisp',
      value: 'Twinning Wisp',
    },
    {
      id: 'No Inclusion',
      label: 'No Inclusion',
      value: 'No Inclusion',
    },
    {
      id: 'Reflecting Surface Graining',
      label: 'Reflecting Surface Graining',
      value: 'Reflecting Surface Graining',
    },
    {
      id: 'Minor details of polish are present',
      label: 'Minor details of polish are present',
      value: 'Minor details of polish are present',
    },
    {
      id: 'Minor details of polish are not shown',
      label: 'Minor details of polish are not shown',
      value: 'Minor details of polish are not shown',
    },
    {
      id: 'Bruise',
      label: 'Bruise',
      value: 'Bruise',
    },
    {
      id: 'Brown patch of color',
      label: 'Brown patch of color',
      value: 'Brown patch of color',
    },
    {
      id: 'Graining',
      label: 'Graining',
      value: 'Graining',
    },
    {
      id: 'Laser Drill Hole',
      label: 'Laser Drill Hole',
      value: 'Laser Drill Hole',
    },
    {
      id: 'Internal Laser Drilling',
      label: 'Internal Laser Drilling',
      value: 'Internal Laser Drilling',
    },
    {
      id: 'Growth Remnant',
      label: 'Growth Remnant',
      value: 'Growth Remnant',
    },
  ],
};
